import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../css/ProductTabs.css";

const ProductTabs = () => {
    const [activeTab, setActiveTab] = useState("hospital");
    const [selectedImage, setSelectedImage] = useState({
        hospital: "TESTDEMO/tanks-Photoroom.png",
        portable: "/TESTDEMO/flowmeter2.jpg",
        specialty: "/TESTDEMO/TOADFULL.jpg"
    });

    const tabLabels = {
        hospital: "Hospital Systems",
        portable: "EMS Systems",
        specialty: "Specialty Systems"
    };

    const imageThumbnails = {
        hospital: [ // placeholder for thumbnail images
            
        ],
        portable: [
            "/TESTDEMO/flowmeter3.jpg",
            "/TESTDEMO/flowmeter4.jpg",
            "/TESTDEMO/flowmeter5.jpg"
        ],
        specialty: [
            "/TESTDEMO/TOADFULL.jpg",
            "/TESTDEMO/5da.jpg",
            "/TESTDEMO/5da1.JPG"
        ]
    };

    const productDetails = {
        hospital: {
            title: "Oxygen Delivery System",
            description: "With a fully mechanical design, our hospital oxygen delivery systems are engineered for high flow throughput and precise oxygen control, making them ideal for medical use.",
            features: [
                "✔ Precise oxygen control for medical use with quick delivery",
                "✔ Full mechanically with no eletronic requirements",
                "✔ Designed for high flow throughput",
                "✔ Durable Easy to maintain",
                "✔ Ideal and easy control over  flows and blend"
            ]
        },
        portable: {
            title: "Flowmeter",
            description: "One of our most popular products, the flowmeter is designed for portable oxygen delivery. It features a compact design and user-friendly controls, making it ideal for on-the-go care.",
            features: [
                "✔ Compact and easy to carry",
                "✔ Long-lasting durable design",
                "✔ User-friendly controls",
                "✔ Suitable for travel and on-the-go care"
            ]
        },
        specialty: {
            title: "Specialty Oxygen System",
            description: "Custom oxygen systems designed for unique healthcare applications. Of those specialty system we have the TOAD (total oxygen administration device), and the transfill cascade system.",
            features: [
                "✔ Tailored solutions for specialized needs",
                "✔ High efficiency and reliability",
                "✔ Advanced safety features",
                "✔ Innovative design for diverse applications"
            ]
        }
    };

    return (
        <section className="products-section">
            <div className="container">
                <div className="header">
                    <span className="badge">Product Line</span>
                    <h2 className="title">Comprehensive Oxygen Delivery Solutions</h2>
                    <p className="description">
                        From portable units to hospital-grade systems, our product range meets the diverse needs of modern healthcare providers.
                    </p>
                </div>

                <div className="tabs">
                    <div className="tabs-list">
                        {Object.keys(tabLabels).map((tab) => (
                            <button
                                key={tab}
                                onClick={() => setActiveTab(tab)}
                                className={`tab-button ${activeTab === tab ? "active" : ""}`}
                            >
                                {tabLabels[tab]}
                            </button>
                        ))}
                    </div>
                </div>

                <div className="tab-content">
                    <div className="product-container">

                        <div className="product-images-container2">
                            <div className="product-images">
                                <img
                                    src={selectedImage[activeTab]}
                                    alt="Product Display"
                                    className="product-image1"
                                />
                            </div>

                            <div className="thumbnail-column">
                                {imageThumbnails[activeTab].map((image, index) => (
                                    <img
                                        key={index}
                                        src={image}
                                        alt={`Thumbnail ${index + 1}`}
                                        className="thumbnail-image"
                                        onClick={() => setSelectedImage((prev) => ({ ...prev, [activeTab]: image }))}
                                    />
                                ))}
                            </div>
                        </div>

                        <div className="product-info">
                            <h3 className="product-title">{productDetails[activeTab].title}</h3>
                            <p className="product-description">{productDetails[activeTab].description}</p>
                            <ul className="features-list1">
                                {productDetails[activeTab].features.map((feature, index) => (
                                    <li key={index} className="feature-item1">{feature}</li>
                                ))}
                            </ul>
                            <Link to="/products" className="learn-more">Learn More</Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProductTabs;
